/** 数组字符串 */
const arrayString = () => { };

/**
 * 字符串转数组
 * @param str 字符串
 * @param separator 分割符，默认：@
 * @returns 
 */
arrayString.stringToArray = (str: string, separator: string = '@'): string[] => {
    let arr: Array<any> = [];
    if (str.trim() !== '') {
        arr = str.split(separator);
    }
    return arr;
}

/**
 * 数组转字符串
 * @param arr 数组
 * @param separator 分割符，默认：@
 * @returns 
 */
arrayString.arrayToString = (arr: string[], separator: string = '@'): string => arr.join(separator);

/**
 * 在数组末尾添加元素
 * @param arr 数组
 * @param newItems 元素
 * @returns 
 */
arrayString.addItem = (arr: string[], ...newItems: string[]): string[] => [...arr, ...newItems];

/**
 * 在数组末尾添加元素（如果不存在的話）
 * @param arr 数组
 * @param newItems 元素
 * @returns 
 */
arrayString.addItemUnique = (arr: string[], ...newItems: string[]): string[] => {
    const newArray = [...arr];
    newItems.forEach(item => {
        if (!newArray.includes(item)) { // 检查是否已存在
            newArray.push(item);
        }
    });
    return newArray;
};

/**
 * 在指定索引插入元素
 * @param arr 数组
 * @param index 索引
 * @param newItems 元素
 * @returns 
 */
arrayString.insertItem = (arr: string[], index: number, ...newItems: string[]): string[] => {
    const newArray = [...arr];
    newArray.splice(index, 0, ...newItems);
    return newArray;
};

/**
 * 在在指定索引插入元素（如果不存在的話，过滤掉已存在的元素）
 * @param arr 数组
 * @param index 索引
 * @param newItems 元素
 * @returns 
 */
arrayString.insertItemUnique = (arr: string[], index: number, ...newItems: string[]): string[] => {
    const newArray = [...arr];
    const itemsToInsert = newItems.filter(item => !newArray.includes(item)); // 过滤掉已存在的元素
    newArray.splice(index, 0, ...itemsToInsert);
    return newArray;
};

/**
 * 使用 Set 进行去重（返回全新去重数组）
 * @param arr 数组
 * @returns 
 */
arrayString.deduplicateArray = (arr: string[]): string[] => Array.from(new Set(arr));

/**
 * 根据索引删除元素
 * @param arr 数组
 * @param index 索引
 * @returns 
 */
arrayString.removeItemByIndex = (arr: string[], index: number): string[] => {
    if (index < 0 || index >= arr.length) return arr;
    const newArray = [...arr];
    newArray.splice(index, 1);
    return newArray;
};

/**
 * 删除元素
 */
arrayString.rmoveItem = {
    /**
     * 删除基本类型数组中的指定值
     * @param arr 数组
     * @param value 值
     * @returns 
     */
    byValue: (arr: string[], value: string): string[] => {
        const index = arr.indexOf(value);
        if (index === -1) return arr;
        return arr.filter((_, i) => i !== index);
    },
    /**
     * 删除对象数组中指定属性等于指定值的元素
     * @param arr 数组
     * @param value 值
     * @param options 选项
     * @returns 
     */
    byKey: <T extends Record<string, any>>(
        arr: T[],
        value: any,
        options?: {
            /** 对象数组中指定属性，默认：'id' */
            key?: string
        }
    ): T[] => {
        const key = options?.key ?? 'id';
        return arr.filter(item => item[key] !== value);
    }
};

/**
 * 覆盖指定索引的元素
 * @param arr 数组
 * @param index 数组
 * @param newValue 值
 * @returns 
 */
arrayString.updateItem = (arr: string[], index: number, newValue: string): string[] => {
    if (index < 0 || index >= arr.length) return arr;
    const newArray = [...arr];
    newArray[index] = newValue;
    return newArray;
};

/**
 * 查找值的索引
 * @param arr 数组
 * @param value 值
 * @returns 
 */
arrayString.findIndex = (arr: string[], value: string): number => arr.indexOf(value);

/**
 * 检查是否包含某个值
 * @param arr 数组
 * @param value 值
 * @returns 
 */
arrayString.contains = (arr: string[], value: string): boolean => arr.includes(value);

/**
 * 获取数组长度
 * @param arr 数组
 * @returns 
 */
arrayString.getLength = (arr: string[]): number => arr.length;

/**
 * 清空数组
 * @returns 
 */
arrayString.clearArray = (): string[] => [];

/** 数组字符串 */
export default arrayString;